/* Park Friends: keep the product page's offer ladder telling the truth.
   ---------------------------------------------------------------------------------------
   The block is rendered by snippets/pf-offer.liquid, so it is right on load and right on
   every full page view. Two things happen without a page view, and this file handles both:

     the cart changes    assets/cart.js re-fetches the page but swaps only the drawer's body
                         and footer, so the product page would keep the sentence it was born
                         with ("Add 1 more jersey, save 25%") while the drawer moves on.
     the size changes    these jerseys are priced by size, and product.js does not replace
                         the block, so the rungs would keep quoting the size the page loaded
                         with while the price above them shows another one.

   Neither the ladder nor any money is computed here. The same snippet writes the tiers and
   the wording into the block as JSON, and every per-variant figure as a money string Liquid
   already formatted, so there is one source and no currency is assembled in the browser. */
(function () {
  'use strict';

  var BLOCK = '[data-pf-ladder]';
  /* What the last look at the cart said. Kept so a size change can re-quote the block
     straight away instead of waiting on another round trip. */
  var lastQty = null;

  function config(block) {
    var el = block.querySelector('[data-pf-ladder-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function prices(block) {
    var el = block.querySelector('[data-pf-ladder-prices]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* The size picker changes the price, and these jerseys are priced by size: Sucios 619 is
     $89.99 up to Womens and $99.99 at Mens. Every rung is re-quoted from the money strings
     Liquid already formatted for that variant, so the block never contradicts the price
     shown above it and no currency is assembled here. */
  function repriceTo(block, variantId) {
    var map = prices(block);
    var row = map && map[String(variantId)];
    if (!row) return;
    block.setAttribute('data-pf-base-money', row.b);
    var rungs = block.querySelectorAll('[data-pf-rung-index]');
    for (var i = 0; i < rungs.length; i++) {
      var idx = parseInt(rungs[i].getAttribute('data-pf-rung-index'), 10) - 1;
      var money = row.e[idx];
      if (!money) continue;
      rungs[i].setAttribute('data-pf-each', money);
      var out = rungs[i].querySelector('[data-pf-each-out]');
      if (out) out.textContent = money;
    }
  }

  /* The rung the cart is standing on, and the one above it. Same rules as the Liquid
     (snippets/pf-offer.liquid, 2026-09-26): the rung REACHED is the percentage the till has
     actually allocated on the cart, never the item count; the count of eligible items only
     decides the next rung and how many more it takes. So the block can never mark "you are
     here" on a rung the checkout button does not show. */
  function line(cfg, qty, realPct) {
    var tiers = cfg.tiers || [];
    if (!tiers.length) return null;
    var top = tiers[tiers.length - 1];
    realPct = realPct || 0;

    if (realPct >= top.pct) {
      return { text: (cfg.top || '').replace('[pct]', realPct), atTop: true, reached: top.qty };
    }
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (realPct < tiers[i].pct) { next = tiers[i]; break; }
    }
    if (!next) return null;
    var n = next.qty - qty;
    var noun = cfg.noun || 'jersey';
    var reached = 0;
    for (var j = 0; j < tiers.length; j++) { if (realPct >= tiers[j].pct) reached = tiers[j].qty; }
    /* The count already covers the next rung and the till is still taking less. Same state the
       Liquid calls stalled (snippets/pf-offer.liquid): it happens when the theme's eligible list
       is wider than the admin discount, and the old Math.max(1, ...) turned it into "Add 1 more
       item, save 20%" for a shopper already holding three. State the offer, promise nothing. */
    if (n < 1) {
      return { text: cfg.stalled || '', atTop: false, reached: reached, nextQty: 0, stalled: true };
    }
    return {
      text: tpl(n),
      atTop: false,
      reached: reached,
      nextQty: next.qty,
    };
    function tpl(count) {
      var t = qty > 0 ? (cfg.next || '') : (cfg.first || '');
      return t.replace('[n]', count).replace('[noun]', count > 1 ? noun + 's' : noun).replace('[pct]', next.pct);
    }
  }

  /* The largest percentage Shopify has actually allocated on the cart: every line's
     line_level_discount_allocations, plus any percentage order discount at cart level.
     Zero when nothing is allocated, whatever the count says. */
  function realPercent(cart) {
    var best = 0;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var allocs = items[i].line_level_discount_allocations || [];
      for (var a = 0; a < allocs.length; a++) {
        var app = allocs[a].discount_application || {};
        if (app.value_type === 'percentage' && Number(allocs[a].amount) > 0) best = Math.max(best, Math.round(parseFloat(app.value) || 0));
      }
    }
    var carts = cart.cart_level_discount_applications || [];
    for (var c = 0; c < carts.length; c++) {
      if (carts[c].value_type === 'percentage' && Number(carts[c].total_allocated_amount) > 0) best = Math.max(best, Math.round(parseFloat(carts[c].value) || 0));
    }
    return best;
  }

  var lastReal = 0;
  function paint(qty, realPct) {
    lastQty = qty;
    if (typeof realPct === 'number') lastReal = realPct;
    var blocks = document.querySelectorAll(BLOCK);
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var cfg = config(block);
      if (!cfg) continue;
      var res = line(cfg, qty, lastReal);
      if (!res) continue;

      var p = block.querySelector('[data-pf-next-tier]');
      if (p) p.textContent = res.text;
      var box = block.querySelector('[data-pf-next-tier-box]');
      if (box) { box.classList.toggle('is-top', res.atTop); box.classList.toggle('is-stalled', !!res.stalled); }

      /* The rung the shopper is on and the rung one more jersey reaches, so the block and the
         sentence agree. Two states, not one: the card marks them differently on purpose, so
         "you are here" is never mistaken for "this is the goal". */
      var rungs = block.querySelectorAll('[data-pf-rung]');
      var nextEach = null;
      for (var r = 0; r < rungs.length; r++) {
        var q = parseInt(rungs[r].getAttribute('data-pf-rung'), 10);
        var isNext = !res.atTop && q === res.nextQty;
        rungs[r].classList.toggle('is-now', res.reached > 0 && q === res.reached);
        rungs[r].classList.toggle('is-next', isNext);
        if (isNext) nextEach = rungs[r].getAttribute('data-pf-each');
      }

      /* The money line. Both figures are strings Liquid already formatted onto the block and
         the rungs, so no currency is assembled here: a client-side "$" would be wrong the
         day the store sells in a second currency. Hidden at the top rung, where there is
         nothing to add, and on anything the snippet marked as having no price to quote. */
      var money = block.querySelector('[data-pf-next-money]');
      if (money) {
        var from = block.getAttribute('data-pf-base-money');
        var tpl = money.getAttribute('data-pf-tpl');
        if (block.hasAttribute('data-pf-no-money') || res.atTop || !nextEach || !from || !tpl) {
          money.hidden = true;
        } else {
          money.textContent = tpl
            .replace('[noun]', cfg.noun || 'jersey')
            .replace('[from]', from)
            .replace('[to]', nextEach);
          money.hidden = false;
        }
      }
    }
  }

  /* How many items in this cart the offer actually covers.

     cart.item_count counts everything, and the quantity discount in the Shopify admin runs on a
     jersey collection: a shopper who adds the MexicoPullover jacket to two jerseys would watch
     this block climb to "Best tier unlocked, 30%" for a rung checkout is never going to give
     them. The eligible product types are written onto the block by snippets/pf-offer.liquid,
     from the same theme setting the Liquid reads, so the two counts cannot drift.

     No list on the block means no restriction, which is a store with no exclusions. */
  function eligibleCount(cart, cfg) {
    var types = (cfg && cfg.types) || [];
    var handles = (cfg && cfg.handles) || [];
    if (!types.length && !handles.length) return cart.item_count;
    var items = cart.items || [];
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var t = String(items[i].product_type || '').trim().toLowerCase();
      var h = String(items[i].handle || '').trim().toLowerCase();
      /* CONTAINS, to stay level with snippets/pf-offer-eligible.liquid, which matches the admin:
         the Jerseys smart collection is five "TYPE CONTAINS <x>" rules, not five equals. */
      var hit = handles.indexOf(h) > -1;
      for (var j = 0; !hit && j < types.length; j++) {
        if (types[j] && t.indexOf(types[j]) > -1) hit = true;
      }
      if (hit) n += items[i].quantity;
    }
    return n;
  }

  function refresh() {
    var block = document.querySelector(BLOCK);
    if (!block) return;
    var cfg = config(block);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') paint(eligibleCount(c, cfg), realPercent(c)); })
      .catch(function () { /* the server-rendered line stands */ });
  }

  window.addEventListener('updated.ecomify.cart', refresh);

  /* The theme fires this from assets/product.js with the whole variant object. */
  window.addEventListener('variantChange.ecomify.product', function (e) {
    var v = e && e.detail;
    if (!v || !v.id) return;
    var blocks = document.querySelectorAll(BLOCK);
    for (var i = 0; i < blocks.length; i++) repriceTo(blocks[i], v.id);
    if (lastQty === null) refresh(); else paint(lastQty, lastReal);
  });

  /* One read on load. The page can be served from a cache that predates the cart the shopper
     is actually carrying, and the whole point of this block is that the sentence is true. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
